<template>
  <section class="App-root g-body" id="app">
    <AppHeader ref="header" :current-nav="currentIndex" :product-list="baseData.productList"></AppHeader>
    <article class="g-content">
      <index-ad ref="indexAd" :module-data="pageData.business" :swiper-img="pageData.rotation"></index-ad>
      <!--多行业解决方案 start-->
      <index-solutions ref="solutions" :moduleData="pageData.solutions"></index-solutions>
      <!--多行业解决方案 end-->
      <!--业务类型 start-->
      <index-new-product ref="businessList" :animate-show="true" :business-list="pageData.businessList" @scrollBox="scrollBox"></index-new-product>
      <!--业务类型 end-->
      <!--我要定制 start-->
      <recommend></recommend>
      <!--我要定制 end-->
      <!--上线产品 start-->
      <index-case ref="indexCase" :animate-show="true" :case-list="pageData.pushData"></index-case>
      <!--上线产品 end-->
      <News :news-list="pageData.newsList.newsList" :news2-list="pageData.newsList1.newsList"></News>
      <!-- 轮播Logo start-->
      <index-logo-list ref="indexLogoList" :logo-arr="pageData.caseList" @jumpToHref="jumpToHref"></index-logo-list>
      <!-- 轮播Logo end-->
    </article>
    <AppFooter :animate-show="animateShow.appFooter" ref="appFooter" :current-nav="currentIndex" :module-data="baseData.site_info"></AppFooter>
  </section>
</template>
<script>
import AppHeader from '../../components/global/AppHeader';
import AppFooter from '../../components/global/AppFooter';
import News from '@/components/News';
import IndexCase from '@/views/index/index-case';
import IndexLogoList from '@/views/index/index-logo-list';
import IndexAd from '@/views/index/index-ad';
import IndexSolutions from '@/views/index/index-solutions';
import IndexNewProduct from '@/views/index/index-new-product';
import Recommend from '@/components/Recommend';
export default {
  name       : 'App',
  components : {Recommend, IndexNewProduct,  IndexSolutions, IndexAd, IndexLogoList, IndexCase, News, AppHeader, AppFooter},
  data(){
    return {
      currentIndex : 0,
      pageData     : {
        rotation     : [], // 轮播图
        business     : [],
        pushData     : [ // 成功案例
        ],
        businessList : [ // 我们的业务
        ],
        caseList     : [// 合作伙伴logo
        ],
        newsList     : {//新闻动态
          name     : '',
          newsList : []
        },
        newsList1    : {//技术团队
          name:'',
          newsList:[]
        },
        solutions    : [ // 多行业解决方案
        ],
      },
      animateShow  : {
        appFooter    : false,
      },
      baseData:{
        productList:[],
        site_info:{}
      }
    };
  },
  computed : {},
  created(){
  },
  mounted(){
    this.getBaseData();
    this.getDataList();
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  methods  : {
    handleScroll(){ // 实现当滚动到指定位置，触发动画
      let _this = this;
      let refArray = Object.keys(this.animateShow);
      this.$nextTick(() => {
        refArray.forEach((r, i) => {
          _this.gdjz(r, 20, _this.animateShow[r], () => {
            _this.animateShow[r] = true;
          });
        });
        this.$refs.header.hideHead();
      });
    },
    gdjz(div, offset, isScroll, callback){
      let dom = this.$refs[div];
      if (dom && !isScroll) {
        var a,
            b,
            c,
            d;
        // console.log(dom);
        if (!dom.$el) {
          return;
        }
        d = dom.$el.offsetTop; // 元素距离相对父级的高度，这里父级指的是body
        a = eval(d + offset);
        b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; //  获取窗口滚动条高度
        c = document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
        // console.log(a,b,c);
        if (b + c > a) {
          setTimeout(() => {
            window.scrollTo(0, b + dom.$el.offsetHeight);
          }, 400);
          callback && callback();
        }
      }
    },
    jumpToHref(url){ // 跳转页面
      if (url) {
        location.href = url;
      }
    },
    getRotation(){ // 加载轮播图
      this.$api.get('home/index/rotation', {type : 14}).then((res) => {
        this.pageData.rotation = res.data || [];
      })
    },
    getDataList(){ // 获取首页数据
      this.$api.get('').then((res) => {
        if (res.data.business) {
          res.data.business.map((item, index) => {
            item.unit = item.title.replace(/\d/g, '');
            item._title = 0;
            return item;
          });
        }
        this.pageData = Object.assign(this.pageData,res.data);
      });
    },
    getBaseData(){ // 获取基本数据
      this.getRotation();
      this.$api.getBase().then((res)=>{
        this.baseData = res;
      })
    },
    scrollBox(){
      var b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; //  获取窗口滚动条高度
      let box = this.$refs.businessList;
      if(box && box.$el){
        window.scrollTo(box.$el.offsetTop, box.$el.offsetTop + 600);
      }
    }
  },
};
</script>
<style scoped lang="scss">
</style>
